module.exports = __webpack_public_path__ + "img/chris_g_12.44cac8b4.jpg";